import React from 'react';
import { InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';
import { USDollarCurrency } from '../../Configurations/ExpenseEntryConfig';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: ({ disabled }) => (disabled ? 'transparent' : COLORS.LT_MIDNIGHT5),
        padding: '0 12px',
        maxHeight: 'none',
        alignSelf: 'stretch',
        '& .MuiTypography-root': {
            fontSize: '14px',
            fontWeight: '400',
            color: COLORS.LT_MIDNIGHT,
            opacity: ({ disabled }) => (disabled ? 0.5 : 1),
        },
    },
    positionEnd: {
        marginLeft: 0,
    },
}));

export const USDollarCurrencyInputAdornment = ({ disabled = false }) => {
    const classes = useStyles({ disabled });

    return (
        <InputAdornment
            position="end"
            classes={{
                root: classes.root,
                positionEnd: classes.positionEnd,
            }}
        >
            {USDollarCurrency.name}
        </InputAdornment>
    );
};

export default USDollarCurrencyInputAdornment;
